export default {
   development: {
       recapctha: '6Lf5wNckAAAAAHlajoHobqQAraYRs9i_dX3J28iY',
       turnstile: '1x00000000000000000000BB'
   },
    staging: {
        recapctha: '6LeoOSkaAAAAAMibOldEeGeIyOJ_PXfAdVn8d1Dp',
        turnstile: '0x4AAAAAABeIe4MMU_SCUXGN'
    },
    production: {
        recapctha: '6LfxwXspAAAAAGefGUACQGpcVqTtdBQyo49Mps2_',
        turnstile: '0x4AAAAAABdJySKZDF0S2iI4'
    }
}[process.env.RAILS_ENV]